import React from 'react';

function formatTime(date) {
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

function PaperclipIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48" />
    </svg>
  );
}

export default function MessageBubble({ message }) {
  const { role, text, fileName, timestamp } = message;
  const isUser = role === 'user';

  return (
    <div className={`assistant-message-bubble ${isUser ? 'user' : 'assistant'}`}>
      <div className="bubble-content">
        {fileName && (
          <div className="file-attachment">
            <PaperclipIcon />
            <span>{fileName}</span>
          </div>
        )}
        <p>{text}</p>
      </div>
      <span className="bubble-time">{formatTime(timestamp)}</span>
    </div>
  );
}
